import { SidebarNavigationItem } from '@air/component-sidebar-navigation';
import { ImagesIcon } from '@air/design-icons';
import { useAirModal } from '@air/provider-modal';

import { LibraryBrowseModal } from '~/components/LibraryBeta/LibraryBrowseModal/LibraryBrowseModal';

export const SidebarNavigationItemBrowseLibraries = () => {
  const [showLibraryBrowseModal] = useAirModal(LibraryBrowseModal);

  return (
    <SidebarNavigationItem
      data-id="browse-libraries"
      onClick={showLibraryBrowseModal}
      prefix={<ImagesIcon className="size-4" />}
    >
      <span className="truncate">Browse libraries</span>
    </SidebarNavigationItem>
  );
};
